<template>
  <el-dialog class="dialog-1"
    :visible.sync="dialogVisible"
    top="8vh"
    width="95vw"
    :close-on-click-modal="false" :show-close="false" @close="onClose">
    <el-tabs type="border-card" v-model="isEditor">
      <el-tab-pane label="查看" name="view">
        <el-button size="mini" @click="download">下 载</el-button>
        <MeterViewDiagram ref="MeterViewDiagramRef" v-if="dialogVisible&&excel_list2.length>0&&(isEditor==='view')" :is-editor="false" :excel_list="excel_list2" @onLoad="onLoad" @onClickMeter="onClickMeter"/>
      </el-tab-pane>
      <el-tab-pane label="编辑" name="editor">
        <MeterViewDiagram ref="MeterViewDiagramRef" v-if="dialogVisible&&excel_list2.length>0&&(isEditor==='editor')" :is-editor="true" :excel_list="excel_list2" @onLoad="onLoad" @onClickMeter="onClickMeter"/>
      </el-tab-pane>
      <el-tab-pane disabled label="节点编辑" name="MeterMapEditor">
        <MeterMapEditor v-if="isEditor==='MeterMapEditor'"/>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">关 闭</el-button>
  </span>
  </el-dialog>
</template>

<script>
import MeterViewDiagram from "./MeterViewDiagram";
import MeterMapEditor from "./MeterMapEditor";
import MeterHttp from "../../../common/MeterHttp";
export default {
  name: "MeterMap",
  provide(){
    return{
      setCard:this.setCardIndex
    }
  },
  inject:['mainObj','componentId','setComponentId',],
  components: {MeterMapEditor, MeterViewDiagram},
  data(){
    return{
      dialogVisible:false,
      meter_id:null,
      excel_list2:[],
      isEditor:'view',
    }
  },
  methods:{
    show(meter_id,callback){
      const that=this;
      that.mainObj.map_id=meter_id;
      that.meter_id=meter_id;
      that.onLoad(callback);
    },
    onClose(){

    },
    onLoad(callback){
      const that=this;
      MeterHttp.post("Meter/getMapTree?user_type="+(that.$route.query.type||0),{
        project_id:that.mainObj.project_id,
        meter_id:that.meter_id,
      },ret=>{
        if(ret.code){
          that.excel_list2=ret.data;
          that.dialogVisible=true;
        }else {
          that.$message.error(ret.msg||"数据异常")
        }
        typeof callback==="function"&&callback(ret)
      });
    },
    download(){
      this.$refs.MeterViewDiagramRef.download();
    },
    editorBtn(){
      this.isEditor=this.isEditor==='view'?'editor':'view';
    },
    setCardIndex(cardIndex){
      this.isEditor=cardIndex;
    },
    onClickMeter(node){
      const that=this;
      that.show(node.id,function () {
        setTimeout(function () {
          that.$refs.MeterViewDiagramRef.reData()
        },500);
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.dialog-1{
  >>>.el-dialog__body{
    padding: 0;
  }
  >>>.el-dialog__header{
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/MeterMap.vue